
const ParentName = ["总经理:总经理", "总监:总监", "会计:会计", "出纳:出纳",
  "助理:助理", "仓管员:仓管员", "质管员:质管员", "销售员:销售员", "部门经理:部门经理",
  "普通员工:普通员工"];

const flowName = [
  "SaleOrder: 销售订单", "SAPSaleOrder: sAP销售订单",
];

const statusText = [
  "启用: 启用", "禁用: 禁用",
];

const repairMan = [
  "张峰: 张峰", "吴伟龙: 吴伟龙", "金鸣华: 金鸣华",
];
const shelfCode = [
  "YDLC01: YDLC01", "YDLC02: YDLC02", "YDLC03: YDLC03","YDLC04: YDLC04","YDLC05: YDLC05","YDLC06: YDLC06",
];
const extMaterialGroup1 = [
  "其他: 其他", "ST: ST", "GD: GD",
];
const extMaterialGroup = [
  "Z1: Z1", "Z2: Z2",
];

const RISK_CLASS = [
  "A: 高风险",
  "B: 中风险",
  "C: 低风险",
  " : ",
];

const BLOCK_REASON = [
  "01: 已超过信贷限额",
  "02: 不足分数",
  "03: 欺诈风险",
  "04: 不可保险",
];


let exportObj = {
  //departmentName,
  ParentName,
  flowName,
  statusText,
  repairMan,
  shelfCode,
  extMaterialGroup1,
  extMaterialGroup,
  RISK_CLASS,
  BLOCK_REASON,
};

//------------------------------以下部分请勿改动------------------------------
//转化为object和options
for (let key in exportObj) {
  let value = exportObj[key];
  if (Array.isArray(value)) {
    let options = [];
    let object = {};
    value.forEach(item => {
      let itemArr = item.split(":");
      let option = {
        value: itemArr[0],
        label: itemArr[1],
      };
      object[option.value] = option.label;
      options.push(option);
    });
    value.$options = options;
    value.$object = object;
  }
}
export default exportObj;
